import { render } from "./UserRanking.vue?vue&type=template&id=048c4368&ts=true"
import script from "./UserRanking.vue?vue&type=script&lang=ts"
export * from "./UserRanking.vue?vue&type=script&lang=ts"

import "./UserRanking.vue?vue&type=style&index=0&id=048c4368&lang=scss"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__